import { motion } from "framer-motion";
import { cardHover } from "../animations";

export const PremiumCard = ({ children, className = "", delay = 0 }) => {
  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      animate="rest"
      variants={cardHover}
      className={`
        relative overflow-hidden
        bg-white/80 backdrop-blur-xl
        rounded-3xl
        border border-gray-100
        shadow-lg hover:shadow-2xl
        transition-shadow duration-300
        ${className}
      `}
      style={{
        willChange: "transform"
      }}
    >
      {/* Gradient overlay on hover */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-[#1f7db6]/5 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none"
      />
      
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
};
